import { Box, Button, Typography } from "@mui/material";
import { styles } from "./CoAMigrationBanner.styles";
import { useIntl } from "react-intl";
import { CampaignOutlined } from "@mui/icons-material";
import { Routes } from "../utils/routesUtils";

export const CoAMigrationBanner = ({ entitySubdomain }: { entitySubdomain: string }) => {
  const intl = useIntl();
  const handleClick = () => {
    if (window.location.pathname.includes("/workforce")) {
      window.location.href = Routes.migrationView(entitySubdomain, "workforce");
    } else if (window.location.pathname.includes("/budgets") || window.location.pathname.includes("/budgeting")) {
      window.location.href = Routes.migrationView(entitySubdomain, "budgets");
    } else if (window.location.pathname.includes("/reporting")) {
      window.location.href = Routes.migrationView(entitySubdomain, "report");
    } else {
      window.location.href = Routes.migration(entitySubdomain);
    }
  };

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.innerWrapper}>
        <CampaignOutlined sx={styles.icon} />
        <Typography variant="h5" sx={styles.bannerText}>
          {intl.formatMessage({
            defaultMessage:
              "To ensure data integrity, migrate existing Budgets, Workforce Plans & Reports (Next Gen) to the updated Chart of Accounts.",
          })}
        </Typography>
        <Button variant="contained" color="primary" sx={styles.migrateNowBtn} onClick={handleClick}>
          {intl.formatMessage({
            defaultMessage: "Migrate now",
          })}
        </Button>
      </Box>
    </Box>
  );
};
